import {
	Box,
	Card,
	CardHeader,
	Divider,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Link,
} from '@material-ui/core';
import moment from 'moment';
import { useSelector, shallowEqual } from 'react-redux';

import { getPlanData } from '../../utils';
import { PayStatus } from "../common";

function ApiManagment() {
	const {
		state,
		limit,
		next_bill_date: nextBillDate,
		planId,
		current,
		nextResetAt,
		paidAt,
		createdAt
	} = useSelector((_state) => _state.subscription, shallowEqual);

	let { cancelUrl } = useSelector((_state) => _state.subscription, shallowEqual);

	const profile = useSelector((_state) => _state?.profile, shallowEqual);

	if (cancelUrl)
		cancelUrl = `${cancelUrl}?prefilled_email=${encodeURIComponent(profile?.email)}`;

	const plan = getPlanData(state, planId);

	return (
		<Card sx={{ 'overflow-x': 'auto' }}>
			<CardHeader subheader="" title="Current plan" />
			<Divider />
			<Box sx={{ minWidth: 800 }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell align="center">Plan</TableCell>
							<TableCell align="center">Cost</TableCell>
							<TableCell align="center">Created</TableCell>
							<TableCell align="center">Status</TableCell>
							<TableCell align="center">Shipments Limit</TableCell>
							<TableCell align="center">Current Shipments</TableCell>
							{nextBillDate && <TableCell align="center">Next payment date</TableCell>}{' '}
							<TableCell align="center">Limit reset date</TableCell>
							{cancelUrl && <TableCell align="center">Manage</TableCell>}
						</TableRow>
					</TableHead>
					<TableBody>
						<TableRow hover>
							<TableCell align="center">{plan?.title}</TableCell>
							<TableCell align="center">${plan?.price}</TableCell>
							<TableCell align="center">{moment(paidAt || createdAt).format('DD MMMM YYYY')}</TableCell>
							<TableCell align="center">
								<PayStatus status={state} />
							</TableCell>
							<TableCell align="center">{limit}</TableCell>
							<TableCell align="center">{current}</TableCell>
							{nextBillDate && (
								<TableCell align="center">
									{state === 'free' ? (
										<PayStatus status={state} />
									) : (
										moment(nextBillDate).format('DD MMMM YYYY')
									)}
								</TableCell>
							)}
							<TableCell align="center">{moment(nextResetAt).format('DD MMMM YYYY')}</TableCell>
							{cancelUrl && (
								<TableCell align="center">
									<Link target="_blank" href={cancelUrl} rel="noreferrer" color="primary">
										Manage
									</Link>
								</TableCell>
							)}
						</TableRow>
					</TableBody>
				</Table>
			</Box>

			{/* <Divider /> */}
			{/* <Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					p: 2,
					height: 68,
				}}
			>
				<Button color="primary" variant="contained" onClick={handleNewApikey}>
					New API key
				</Button>
			</Box> */}
		</Card>
	);
}

export default ApiManagment;
